<template>
  <div>
    <div class="catalog">
      <products v-if="productItems.length > 0" v-on:alertTips="alertTips"
        :productItems="productItems" :shoppingCart="shoppingCart" :scrollY="scrollY" @itemall="itemall"
        @addcart="setaddcart" />
    </div>

    <alert v-if="showAlert" v-on:closeAlertTips="closeAlertTips" :message="showAlertMsg" />
  </div>
</template>

<script>
import alert from "./alert.vue";
import products from "./products.vue";
export default {
  name: "catalog",
  data() {
    return {
      showAlert: false,
      showAlertMsg: "",
      itemAll: {},
      addcart: false,
      shoppingCart: [],
      productItems: [], // 商品資料
    };
  },
  props: {
    scrollY: {
      type: Number,
      defaults: 0,
    }
  },
  async mounted() {
    // 取廠商設定
    const campaignList = await this.getSiteConfig();
    if (!campaignList) {
      console.log('缺少必要資料！'); return;
    }

    // 取活動
    const campaignInfo = await this.getCampaignDetail([campaignList]);
    if (!campaignInfo || !campaignInfo[0] || !campaignInfo[0].campaignRange) {
      console.log('缺少必要資料！'); return;
    }

    this.$emit('setCampaignInfo', campaignInfo[0]);

    const cache = window.sessionStorage.getItem('bestShopAiData');
    if (cache) {
      this.productItems = JSON.parse(cache);
      return;
    }

    const pids = campaignInfo[0].campaignRange.v[9].split(',');
    const productData = await this.getProducts(pids, 3);
    this.productItems = pids.map(v => productData[v]);
    window.sessionStorage.setItem('bestShopAiData', JSON.stringify(this.productItems));
  },
  methods: {
    // 取廠商設定檔
    async getSiteConfig() {
      const { frontApiPath, siteId } = this.configs;
      return await fetch(`${frontApiPath()}bWeb/config?siteId=${siteId()}&version=1`, {
        method: 'GET',
        headers: {
          'content-Type': 'application/json',
        },
      })
        .then((res) => res.json())
        .then((res) => {
          const { resultCode, resultData } = res;
          return resultCode === 0 && resultData[0] && resultData[0].b4Info ? resultData[0].b4Info.campaignList : null;
        });
    },
    // 取活動
    // 正式活動：DO_240913122653447, 測試活動：DO_240910123016535
    async getCampaignDetail(campaignIds) {
      return await fetch(`${this.configs.frontCloudApiPath()}campaign/getInfo`, {
        method: 'POST',
        headers: {
          'content-Type': 'application/json',
        },
        body: JSON.stringify({
          campaignIds: campaignIds,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          const { resultCode, resultData } = res;
          return resultCode === 0 ? resultData : [];
        });
    },
    // 取AI資料
    async getAi(campaignRange) {
      return await fetch(`${this.configs.aiCloudApiPath()}getalist`, {
        method: 'POST',
        headers: {
          'content-Type': 'application/json',
        },
        body: JSON.stringify({
          list_num: 10,
          type: 1,
          target_value: "1052276464.1726035203",
          q1_x: '0.5',
          supplier_y: 1,
          filter: {
            k: campaignRange.k.slice(0, 10),
            v: campaignRange.v.slice(0, 10)
          }
        }),
      })
        .then((res) => res.json())
        .then(async (res) => {
          const data = res && res[0] && res[0].pids && res[0].pids.length > 0 ? res[0].pids : null;
          if (!data) return [];
          const priceData = await this.getProducts(data.map((v) => v.pid));
          const originData = data.map((e) => {
            if (priceData[e.pid]) {
              return {
                ...e,
                ...priceData[e.pid],
                image_url: priceData[e.pid].images && priceData[e.pid].images.replace('-uat2', ''),
              };
            } else {
              return e;
            }
          });
          return originData;
        });
    },
    // 取商品集合資料
    async getProducts(pids, type = 1) {
      const resultData = await fetch(`${this.configs.frontCloudApiPath()}product/v2/productinfo`, {
        method: 'POST',
        headers: {
          'content-Type': 'application/json',
        },
        body: JSON.stringify({
          param: {
            productIdList: pids,
            type,
          },
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          const { resultCode, resultData } = res;
          return resultCode === 0 && resultData.length > 0
            ? resultData.map((v) => {
              const img = v.images && v.images.replace('-uat2', '');
              return Object.assign(v, { pid: v.productId, images: img, image_url: img });
            })
            : null;
        })
        .catch((err) => {
          console.error(err);
          return null;
        });

      return resultData && resultData.length > 0 ? resultData.reduce((p, v) => {
        const idx = v.productId;
        return Object.assign(p, { [idx]: v });
      }, {}) : null;
    },

    getCartItems(items) {
      this.shoppingCart = [];
      this.shoppingCart = items;
    },
    resetcart() {
      this.addcart = false;
    },
    setaddcart() {
      this.addcart = true;
    },
    itemall(v) {
      this.itemAll = Object.assign({}, this.itemAll, v);
    },
    catalogTarget(i) {
      const catalogs = [...document.querySelectorAll('.catalog')];
      const catalogSelTop = catalogs[i].offsetTop;
      window.scrollTo({
        top: catalogSelTop,
        behavior: "smooth"
      });
    },
    alertTips(message) {
      this.showAlertMsg = message;
      this.showAlert = true;
    },
    closeDetail() {
      this.showDetail = false;
    },
    closeAlertTips() {
      this.showAlert = false;
    },
  },
  components: {
    products,
    alert,
  }
};
</script>

<style lang="scss" scoped>
.catalog {
  @media(max-width:768px) {
    padding: 0 10px;
  }

  h2 {
    border-radius: 5px;
    text-align: center;
    padding: 25px 0;
    margin-bottom: 20px;
    color: #fff;
    background: url(../../assets/section-title-bg@2x.png) no-repeat;
    background-size: cover;
    background-position-x: right;
    font-size: 1.125rem;

    @media(max-width:768px) {
      padding: 13px 0;
    }
  }
}
</style>
